import React, { Component } from "react";
import _ from "lodash";
import axios from "axios";
import copyToClipboard from "../../modules/utils/copyToClipboard";

class FormPost extends Component {
  state = {
    currentLink: window.location.href.replace("edit/", "?post="),
    description: "",
    imageId: "",
    isPrivate: false,
    sendTo: "",
    sendURL: ""
  };

  componentDidMount() {
    if (this.props.value) {
      this.setState({
        ...this.props.value
      });
    }
  }

  handleSave = async () => {
    if (this.props.onSave) {
      if (_.isEmpty(this.state.description)) {
        window.M.toast({ html: "Please fill description url." });
        return;
      }

      if (_.isEmpty(this.state.imageId)) {
        window.M.toast({ html: "Please fill imageURL url." });
        return;
      }

      if (_.isEmpty(this.state.sendURL)) {
        window.M.toast({ html: "Please fill send url." });
        return;
      }

      if (_.isEmpty(this.state.sendTo)) {
        await this.onCheckSentTo();
        if (_.isEmpty(this.state.sendTo)) {
          window.M.toast({ html: "Please click check facebook url" });
          return;
        }
      }

      this.props.onSave(this.state);
    }
  };

  onChange = ({ target }) => {
    const { name } = target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    this.setState({ [name]: value });
  };

  onCheckSentTo = async () => {
    try {
      const result = await axios.get("https://cors-anywhere.herokuapp.com/" +this.state.sendURL, { crossdomain: true });
      const html = /content="fb:\/\/profile\/(\w+)/g.exec(
        _.get(result, "data")
      );
      const fbId = _.get(html, 1);
      if (fbId) {
        this.setState({ sendTo: fbId });
        window.M.toast({ html: "facebook url correct!!" });
      } else {
        throw Error("error");
      }
    } catch (error) {
      window.M.toast({ html: "not found url facebook" });
    }
  };

  onCopy = () => {
    copyToClipboard(this.state.currentLink);
    window.M.toast({ html: `copy ${this.state.currentLink} success!!` });
  };

  render() {
    return (
      <div>
        <div className="row">
          <div className="input-field">
            <textarea
              className="materialize-textarea"
              name="description"
              value={this.state.description}
              placeholder="Description"
              onChange={this.onChange}
              style={{ minHeight: "15rem" }}
            />
            <label htmlFor="description" className="active">
              Description
            </label>
          </div>
        </div>
        <div className="row">
          <div className="input-field">
            <input
              type="text"
              name="imageId"
              value={this.state.imageId}
              placeholder="https://cdn.pixabay.com/photo/2018/08/26/14/04/aster-3632294_1280.jpg"
              onChange={this.onChange}
            />
            <label htmlFor="imageId" className="active">
              ImageURL
            </label>
          </div>
        </div>
        <p>
          <label>
            <input
              type="checkbox"
              name="isPrivate"
              className="filled-in"
              checked={this.state.isPrivate}
              onChange={this.onChange}
            />
            <span>Private</span>
          </label>
        </p>

        <br />
        <div className="row right-align">
          <div className="col s8">
            <input
              type="text"
              name="sendURL"
              placeholder="https://www.facebook.com/zuck"
              onChange={this.onChange}
              value={this.state.sendURL}
            />
          </div>
          <div className="col s4">
            <div className="btn" onClick={this.onCheckSentTo}>
              <span>Auto Fill</span>
            </div>
          </div>
        </div>
        <div className="row right-align">
          <div className="col s8">
            <input
              type="text"
              name="sendTo"
              placeholder="fbId ex. 4"
              onChange={this.onChange}
              value={this.state.sendTo}
            />
          </div>
        </div>

        {_.get(this.state, "id") && (
          <React.Fragment>
            <div className="row right-align">
              <div className="col s8">
                <input
                  type="text"
                  name="sendURL"
                  onChange={this.onSendToChange}
                  defaultValue={this.state.currentLink}
                  disabled
                />
              </div>
              <div className="col s4">
                <div className="btn" onClick={this.onCopy}>
                  <span>Copy For Sharing</span>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}

        {/* {this.state.sendTo} */}
        <div className="row right-align">
          <button className="btn" onClick={this.handleSave}>
            Save
          </button>
        </div>
      </div>
    );
  }
}

export default FormPost;



// WEBPACK FOOTER //
// ./src/templates/form-post/FormPost.js